import React, { Component } from 'react';
import ReactDOM from "react-dom";

/**
 * Component to prompt the user to indicate whether their address is a PO box.
 */
class PostOfficeBoxPrompt extends Component {
	
	/**
	 * Show the modal when the component mounts.
	 */
	componentDidMount() {
		window.$(ReactDOM.findDOMNode(this)).modal("show");
		window.$(ReactDOM.findDOMNode(this)).on("hidden.bs.modal", this.props.modalHidden)
		// bootstrap puts a blur on ".modal-open .page-wrapper" and recommends placing modals in a top-level to prevent
		// other CSS from affecting the modal appearance. We can't do this though, because the react root is nested
		// pretty deep in the wrapping DOM, so instead we're programatically dropping the blurry styles
		window.$(".page-wrapper").css({
			"filter": "none",
			"-webkit-filter": "none",
			"-moz-filter": "none",
			"-o-filter": "none",
			"-ms-filter": "none"
		});
	}
	
	/**
	 * Renders the modal component.
	 */
	render() {
		let shippingAddress = this.props.address;
		return (
			<div className="modal fade" id="PostOfficeBoxPromptModal" tabIndex="-1" role="dialog">
				<div className="modal-dialog" role="document">
					<div className="modal-content">
						<div className="modal-header">
							<button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
							<h4 className="modal-title">Post Office Box</h4>
						</div>
						<div className="modal-body">
							<p>Is the patient shipping address a post office box?</p>
							{shippingAddress.address1}<br/>
							{shippingAddress.address2}<br/>
							{shippingAddress.city} {shippingAddress.state} {shippingAddress.zip}
						</div>
						<div className="modal-footer">
							<button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={this.props.affirmPoBox}>Yes</button>
							<button type="button" className="btn btn-light" data-bs-dismiss="modal" onClick={this.props.denyPoBox}>No</button>
						</div>
					</div>
				</div>
			</div>
		);
	};
}

export default PostOfficeBoxPrompt;
